exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Container_container__2941V{margin:0 20px;padding-top:.1px}@media only screen and (min-width:1220px){.Container_container__2941V{margin:0 auto;max-width:1180px}}@media only screen and (max-width:719px){.Container_container__2941V{margin:0 15px}}", ""]);

// exports
exports.locals = {
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"container": "Container_container__2941V"
};